// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


export const organizationNameMinLength = 1;
export const organizationNameMaxLength = 256;

export const OrganizationNameSchema = t.refinement(t.string, n => n.length >= organizationNameMinLength && n.length <= organizationNameMaxLength, 'OrganizationName');

export type OrganizationName = string;
